import { useSearchParams } from "next/navigation"
// We do an exception to use the query from next/router as it's the only way to retrieve the search
// params from a Next.js rewrite containing query params.
// eslint-disable-next-line no-restricted-imports
import { useRouter } from "next/router"

import { parsedUrlQueryToURLSearchParams } from "@/modules/routing/utils"

import { usePrefilteredJobSearch } from "./usePrefilteredJobSearch"

const IGNORED_QUERY_PARAMS = ["pageLocale"]

export const usePrefilteredJobSearchParams = (): URLSearchParams => {
  const searchParams = useSearchParams()
  const isPrefilteredJobSearch = usePrefilteredJobSearch()
  const { query } = useRouter()

  if (isPrefilteredJobSearch) {
    const filteredQuery = Object.fromEntries(
      Object.entries(query).filter(([key]) => !IGNORED_QUERY_PARAMS.includes(key))
    )
    const prefilteredSearchParams = new URLSearchParams(searchParams)

    return parsedUrlQueryToURLSearchParams(filteredQuery, prefilteredSearchParams)
  }

  return searchParams
}
